// src/components/store/sections/hero-banner/HeroV56PolaroidcollageLimeZest.tsx
"use client";

import React from "react";
import DynamicHeroVariant from "./DynamicHeroVariant";

export default function HeroV56PolaroidcollageLimeZest(props: any) {
  return (
    <DynamicHeroVariant
      variantNumber={56}
      archKey="polaroid_collage"
      archLabel="Polaroid Collage Stage"
      palName="LimeZest"
      grad="from-lime-500 via-green-500 to-emerald-700"
      lightBg="bg-lime-50"
      textCol="text-lime-800"
      borderCol="border-lime-200"
      btnCls="bg-emerald-600 hover:bg-emerald-700"
      {...props}
    />
  );
}
